import instantsearch from 'instantsearch.js/dist/instantsearch.production.min';
import { hits, configure, menuSelect, pagination } from 'instantsearch.js/es/widgets';
import { connectPagination, connectRefinementList } from 'instantsearch.js/es/connectors';

import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
const SEARCH_ONLY = import.meta.env.VITE_TYPESENSE_SEARCH_ONLY_API_KEY || '';
const SEARCH_HOST = import.meta.env.VITE_TYPESENSE_HOST || '';
const SEARCH_PORT = import.meta.env.VITE_TYPESENSE_PORT || '';
const indexName = import.meta.env.VITE_SEARCH_INDEX;


const params = new URLSearchParams(window.location.search);
const getInitialCategoriesFromParams = (searchParams) => {
    const q = searchParams.get('q');
    if (typeof q !== 'string' || q.trim() === '') return [];
    return q
        .split(',')
        .map((value) => value.trim())
        .filter((value) => value !== '');
};
const getInitialSearchQueryFromParams = (searchParams) => {
    const legacyQuery = searchParams.get('content[query]');
    return typeof legacyQuery === 'string' && legacyQuery.trim() !== '' ? legacyQuery.trim() : '';
};
const getInitialPageFromParams = (searchParams) => {
    const raw = searchParams.get('pg');
    const parsed = Number.parseInt(raw ?? '', 10);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : 1;
};
const getInitialYearFromParams = (searchParams) => {
    const year = searchParams.get('y');
    return typeof year === 'string' && year.trim() !== '' ? year.trim() : '';
};
const initialCategories = getInitialCategoriesFromParams(params);
const initialSearchQuery = getInitialSearchQueryFromParams(params);
const initialPage = getInitialPageFromParams(params);
const initialYear = getInitialYearFromParams(params);
let hasAppliedInitialCategoryRefinement = false;

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
        apiKey: SEARCH_ONLY, // Be sure to use the search-only-api-key
        nodes: [
            {
                host: SEARCH_HOST,
                port: SEARCH_PORT,
                protocol: "https"
            }
        ]
    },
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  query_by is required.
    additionalSearchParameters: {
        query_by: "prioritizedSearchTerms,title,summary",
        filter_by:'handle:=news'
    }
});
const searchClient = typesenseInstantsearchAdapter.searchClient;

const renderPagination = (renderOptions, isFirstRender) => {
    const {
        pages,
        currentRefinement,
        nbPages,
        isFirstPage,
        isLastPage,
        refine,
        createURL,
        widgetParams
    } = renderOptions;

    const { container } = widgetParams;

    if (nbPages <= 1) {
        container.style.display = 'none';
        return;
    } else {
        container.style.display = 'block';
    }

    const first = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"/></svg>`;
    const previous = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>`;
    const next = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>`;
    const last = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>`;
    widgetParams.container.innerHTML = `
    <div class="query__pagination">
        <ul class="page-nav">
          ${
        !isFirstPage
            ? `
                <li>
                  <a
                    href="${createURL(0)}"
                    data-value="${0}"
                  >
                    ${first}
                  </a>
                </li>
                <li>
                  <a
                    href="${createURL(currentRefinement - 1)}"
                    data-value="${currentRefinement - 1}"
                  >
                    ${previous}
                  </a>
                </li>
                `
            : ''
    }
          ${pages
        .map(
            page => `
                <li ${currentRefinement === page ? 'class="current-page"' : ''}>
                  <a
                    href="${createURL(page)}"
                    data-value="${page}"
                  >
                    ${page + 1}
                  </a>
                </li>
              `
        )
        .join('')}
            ${
        !isLastPage
            ? `
                  <li>
                    <a
                      href="${createURL(currentRefinement + 1)}"
                      data-value="${currentRefinement + 1}"
                    >
                      ${next}
                    </a>
                  </li>
                  <li>
                    <a
                      href="${createURL(nbPages - 1)}"
                      data-value="${nbPages - 1}"
                    >
                      ${last}
                    </a>
                  </li>
                  `
            : ''
    }
        </ul>
    </div>
  `;

    [...container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            refine(event.currentTarget.dataset.value);
        });
    });
};

const customPagination = connectPagination(renderPagination);


const search = instantsearch({
    searchClient,
    indexName: indexName,
    routing: false,
    initialUiState: {
        [indexName]: {
            ...(initialSearchQuery ? { query: initialSearchQuery } : {}),
            ...(initialYear ? { menu: { year: initialYear } } : {}),
            ...(initialPage > 1 ? { page: initialPage } : {})
        }
    },
    onStateChange({ uiState, setUiState }) {
        setUiState(uiState);
        const state = uiState[indexName] || {};
        const selectedCategories = state.refinementList?.newsCategory || [];
        const selectedYear = state.menu?.year || '';
        const page = Number.isInteger(state.page) ? state.page : 1;
        const url = new URL(window.location.href);

        if (selectedCategories.length > 0) {
            const qValue = selectedCategories.map((value) => String(value).toLowerCase()).join(',');
            url.searchParams.set('q', qValue);
        } else {
            url.searchParams.delete('q');
        }

        if (page > 1) {
            url.searchParams.set('pg', String(page));
        } else {
            url.searchParams.delete('pg');
        }

        if (selectedYear) {
            url.searchParams.set('y', selectedYear);
        } else {
            url.searchParams.delete('y');
        }

        if (url.toString() !== window.location.href) {
            window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        }
    },
});

const categoryRefinementList = (renderOptions, isFirstRender) => {
    const { items, refine } = renderOptions;
    const container = document.querySelector('#custom-refinement-list');

    if (!hasAppliedInitialCategoryRefinement && initialCategories.length > 0 && items.length > 0 && !items.some((item) => item.isRefined)) {
        const normalizedInitialCategories = initialCategories.map((value) => value.toLowerCase());
        const matchingItems = items.filter((item) => {
            const label = String(item.label ?? '').trim().toLowerCase();
            const value = String(item.value ?? '').trim().toLowerCase();
            return normalizedInitialCategories.includes(label) || normalizedInitialCategories.includes(value);
        });

        if (matchingItems.length > 0) {
            hasAppliedInitialCategoryRefinement = true;
            matchingItems.forEach((item) => refine(item.value));
            if (initialPage > 1) {
                setTimeout(() => {
                    const currentUiState = search.getUiState();
                    const indexUiState = currentUiState[indexName] || {};
                    if (indexUiState.page !== initialPage) {
                        search.setUiState({
                            ...currentUiState,
                            [indexName]: {
                                ...indexUiState,
                                page: initialPage
                            }
                        });
                    }
                }, 0);
            }
            return;
        }

        // Facets are available but no exact match; stop retrying.
        hasAppliedInitialCategoryRefinement = true;
    }

    if (!hasAppliedInitialCategoryRefinement && initialCategories.length > 0 && items.length === 0) {
        // Wait for facet values to load before deciding whether we can match.
        return;
    }
    if (!hasAppliedInitialCategoryRefinement) {
        hasAppliedInitialCategoryRefinement = true;
    }

    container.innerHTML = `
        <ul class="search__filters">
          ${items
            .map(
                item => `
                <li class="checkbox__wrapper search__checkbox">
                <label class="checkbox__label ${item.isRefined ? 'checked' : ''}">
                  <input class="checkbox__input" type="checkbox" value="${item.value}" ${item.isRefined ? 'checked' : ''} />
                  ${item.label} (${item.count})
                  <span class="hidden${item.isRefined ? ' checked' : ''}"><i class="fa-regular fa-check"></i></span>
                </label>
                </li>`
            )
            .join('')}
        </ul>
    `;
    container.querySelectorAll('input[type="checkbox"]').forEach(input => {
        input.addEventListener('change', event => {
            refine(event.target.value);
        });
    });

};
const customCatRefinementList = connectRefinementList(categoryRefinementList);

const customCatRefList = customCatRefinementList({
    attribute: 'newsCategory', // must match your schema field
    searchable: false,        // optional: allows searching the list
    sortBy: ['isRefined'],    // optional: sort the facet values
    limit: 15
});

const menu = instantsearch.widgets.menuSelect({
    container: '#year-select',
    attribute: 'year', // must match your schema field
    searchable: false,        // optional: allows searching the list
    sortBy: ['name:asc'],    // optional: sort the facet values
    cssClasses: {
        select: [
            'filter__year',
        ],
    },
    templates: {
        defaultOption(data, { html }) {
            return html`<span>Year</span>`;
        },
        item(item, { html }) {
            return html`<span>${item.label} (${item.count.toLocaleString()})</span>`;
        },
    },
});

const searchHits = instantsearch.widgets.hits({
    container: '#hits',
    templates: {
        item(hit, { html, components }) {

            const externalImgCredit =
                hit.externalImgCredit
                    ? html`<p class="news__photo-credit">${hit.externalImgCredit}</p>`
                    : '';
            const newsSourceLogo =
                hit.newsSourceLogoSrc
                    ? html`<img src="${hit.newsSourceLogoSrc}" alt="caption goes here" class="external-source__img"/>`
                    : '';
            const nsTitle =
                hit.newsSourceTitle
                    ? html`<div class="news__external-source"><p class="external-source__title${hit.newsSourceLogoSrc ? html` visually-hidden` : ''}">${hit.newsSourceTitle}</p></div>`
                    : '';
            const newsSource =
                hit.newsSourceUrl
                    ? html`<a href="${hit.newsSourceUrl}" target="_blank" class="news__external-source">${newsSourceLogo}${nsTitle}</a>`
                    : html`${hit.newsSourceTitle ? nsTitle : ''}`;
            const imageSrc =
                hit.imageSrc
                    ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url }" class="results__image ${hit.handle === 'news' ? 'news-featured__image' : 'results__image-image'}"><img src="${hit.imageSrc}" srcset="${hit.imageSrcset}" alt="${hit.imageAltText}" class="${hit.handle === 'news' ? 'news-featured__image-image' : 'results__image-image'}" sizes="(min-width:641px) 30vw, 100vw"/></a>`
                    : '';
            const previewImgSrc =
                hit.previewImgSrc
                    ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url }" class="results__image ${hit.handle === 'news' ? 'news-featured__image' : 'results__image-image'}"><img src="${hit.previewImgSrc}" srcset="${hit.previewImgSrcset}" alt="${hit.previewImgAltText}" class="${hit.handle === 'news' ? 'news-featured__image-image' : 'results__image-image'}" sizes="(min-width:641px) 30vw, 100vw"/></a>`
                    : '';
            const externalImgSrc =
                hit.externalImgSrc
                    ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url }" class="results__image ${hit.handle === 'news' ? 'news-featured__image' : 'results__image-image'}"><img src="${hit.externalImgSrc}" srcset="${hit.externalImgSrcset}" alt="${hit.externalImgAltText}" class="${hit.handle === 'news' ? 'news-featured__image-image' : 'results__image-image'}" sizes="(min-width:641px) 30vw, 100vw"/>${externalImgCredit}</a>`
                    : '';
            const headshotImgSrc =
                hit.headshotImgSrc
                    ? hit.showLink === true ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url }"><img src="${hit.headshotImgSrc}" srcset="${hit.headshotImgSrcset}" alt="${hit.headshotAltTxt}" class="people__image" sizes="(min-width:641px) 30vw, 100vw"/></a>` : html`<div><img src="${hit.headshotImgSrc}" srcset="${hit.headshotImgSrcset}" alt="${hit.headshotAltTxt}" class="people__image" sizes="(min-width:641px) 30vw, 100vw"/></div>`
                    : '';
            const parent = hit.parentUrl !== '' ? html`<p class="results__parent"><a href="${hit.parentUrl}" class="results__link">${hit.parentTitle}</a></p>` : '';
            const peopleBlock =
                hit.handle === 'people'
                    ? html `<div class="news__article-content">
                            ${headshotImgSrc ? headshotImgSrc : '' }
                            <div class="results__right">
                                ${hit.showLink === true ? html`<a href="${hit.url}" class="results__entry-title">${components.Highlight({ attribute: 'title', hit })}</a>` : html`<h3 class="results__entry-title">${components.Highlight({ attribute: 'title', hit })}</h3>` }
                                ${hit.shortBio != '' ? html`<p class="results__description">${components.Highlight({attribute: 'shortBio', hit})}</p>` : hit.personTitle != '' ? html`<p class="results__description">${components.Highlight({attribute: 'personTitle', hit})}</p>` : ''}
                            </div>
                        </div>`
                    : '';
            const contentBlock =
                html`
                    ${newsSource}
                    <div class="news__article-content">

                        ${imageSrc ? imageSrc : previewImgSrc ? previewImgSrc : externalImgSrc ? externalImgSrc : headshotImgSrc ? headshotImgSrc : '' }

                        <div class="results__right">
                            ${hit.handle !== 'news' ? html`${parent}` : '' }
                            <a href="${hit.externalUrl ? hit.externalUrl : hit.url }" class="results__entry-title">
                              ${components.Highlight({ attribute: 'title', hit })} ${hit.externalUrl ? html`<i class="fa-regular fa-arrow-up-right-from-square external-link"></i>` : ''}
                            </a>
                            ${hit.summary != ''
                                ? html`<p class="results__description">${components.Highlight({ attribute: 'summary', hit }) }</p>`
                                : '' }
                            ${hit.handle === 'news'
                                ? html`<div class="news__article-categories">${hit.newsCategory?.map((cat) => {
                                    const catValue = String(cat).toLowerCase();
                                    return html`<a href="?q=${encodeURIComponent(catValue)}" class="news__article-category">${cat}</a> `
                                })}
                                </div>`
                                : ''
                            }
                        </div>
                    </div>
                `;
            return html`
                    ${peopleBlock ? peopleBlock : contentBlock}
                `;
        },
        empty(results, {html}) {
            if (results.query === '') return null;
            return html`No results found for "${results.query}"`;
        },
    }
});

const pageNav = instantsearch.widgets.pagination({
    container: '#pagination',
    cssClasses: {
        root: 'query__pagination',
        list: 'page-nav',
        selectedItem: 'current-page',
    },
    templates: {
        first() {
            return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"/></svg>`
        },
        previous() {
            return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>`
        },
        next() {
            return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>`
        },
        last() {
            return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>`
        },

    },
});

const config = instantsearch.widgets.configure({
    query: initialSearchQuery,
    hitsPerPage: 10
});

search.addWidgets([
    customCatRefList,
    menu,
    searchHits,
    pageNav,
    config,
    customPagination({
        container: document.querySelector('#pagination'),
    })
]);

search.start();
const resetSearchButton = document.getElementById('reset-search');
if (resetSearchButton) {
    resetSearchButton.addEventListener('click', function () {
        search.setUiState({
            [search.indexName]: {
                refinementList: {},
                menu: {},
                page: 0
            }
        });
    });
}


const icon = document.getElementsByClassName('search__mobile-icon')[0]
const filterArea = document.getElementsByClassName('news__right')[0]
icon.addEventListener('click', () => {
    if (filterArea.classList.contains('active')) {
        filterArea.classList.remove('active')
        icon.setAttribute('aria-expanded', 'false')
    }
    else {
        filterArea.classList.add('active')
        icon.setAttribute('aria-expanded', 'true')
    }
})
icon.addEventListener('keypress', (e) => {
    if (e.charCode === 13)
        if (filterArea.classList.contains('active')) {
            filterArea.classList.remove('active')
            icon.setAttribute('aria-expanded', 'false')
        }
        else {
            filterArea.classList.add('active')
            icon.setAttribute('aria-expanded', 'true')
        }
})
